/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

const colors = {
  // Primary brand color (blue modern)
  primary: {
    main: "#2F80ED",
    focus: "#1C6DD0",
  },

  // Secondary color (neutral lavender/slate)
  secondary: {
    main: "#6B7280",
    focus: "#4B5563",
  },

  // Success (green)
  success: {
    main: "#27AE60",
    focus: "#219653",
  },

  // Info (light blue)
  info: {
    main: "#56CCF2",
    focus: "#2D9CDB",
  },

  // Warning (orange)
  warning: {
    main: "#F2994A",
    focus: "#F57C00",
  },

  // Error (red)
  error: {
    main: "#EB5757",
    focus: "#C0392B",
  },

  // Light grey shades
  light: {
    main: "#F9FAFB",
    focus: "#E5E7EB",
  },

  // Dark mode support (if used)
  dark: {
    main: "#111827",
    focus: "#1F2937",
  },

  // Text colors
  text: {
    primary: "#111827",
    secondary: "#4B5563",
    disabled: "#9CA3AF",
  },

  // Backgrounds
  background: {
    default: "#F9FAFB",
    paper: "#FFFFFF",
  },

  // Border colors
  border: {
    main: "#E5E7EB",
    dark: "#D1D5DB",
  },

  // Gradients
  gradients: {
    primary: {
      main: "#2F80ED",
      state: "#1C6DD0",
    },
    secondary: {
      main: "#6B7280",
      state: "#4B5563",
    },
    info: {
      main: "#56CCF2",
      state: "#2D9CDB",
    },
    success: {
      main: "#27AE60",
      state: "#219653",
    },
    warning: {
      main: "#F2994A",
      state: "#F57C00",
    },
    error: {
      main: "#EB5757",
      state: "#C0392B",
    },
    dark: {
      main: "#111827",
      state: "#1F2937",
    },
  },

  // Input placeholder and disabled colors
  inputBorderColor: "#D1D5DB",
  inputLabelColor: "#6B7280",
  inputFilledColor: "#F3F4F6",

  // Shadows
  boxShadows: {
    navbarBoxShadow: `0 2px 4px rgba(0, 0, 0, 0.04)`,
    card: `0 1px 3px rgba(0, 0, 0, 0.1)`,
    input: `0 0 0 1px rgba(209, 213, 219, 1)`,
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#FFFFFF",
    focus: "#F3F4F6",
  },

  black: {
    main: "#000000",
  },

  // Grey palette used by borders.js
  grey: {
    100: "#F3F4F6",
    200: "#E5E7EB",
    300: "#D1D5DB",
    400: "#9CA3AF",
    500: "#6B7280",
    600: "#4B5563",
    700: "#374151",
    800: "#1F2937",
    900: "#111827",
  },

  // Tabs indicator support
  tabs: {
    indicator: {
      boxShadow: "#2F80ED",
    },
  },

  // Colored shadow compatibility
  coloredShadows: {
    primary: "#2F80ED",
    secondary: "#6B7280",
    info: "#56CCF2",
    success: "#27AE60",
    warning: "#F2994A",
    error: "#EB5757",
    light: "#F3F4F6",
    dark: "#111827",
  },
};

export default colors;
